import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username: String;
  password: String;
  public submitted:boolean;
  constructor(private authService:AuthenticationService, private router:Router) {

  
   }

  ngOnInit() {
    this.submitted = true;
    const user= {
      username: this.username,
      password: this.password
    }
    if(this.authService.loggedIn){
      this.authService.getProfile().subscribe((user) => {
        //console.log(user)
          if(user[0].user.email == 'admin@my-media.tv')
          {
            this.router.navigate(['admin/accounts']);
          }else{
            this.router.navigate(['admin/rooms']);
          }

          
      
    });
    }
    this.submitted = false;

  }

  onLoginSubmit(){
    const user= {
      username: this.username,
      password: this.password
    }

    this.authService.authenticateUser(user).subscribe(data =>{
      if(data.success){
        this.authService.storeUserData(data.token, data.user);
        //    this.flashMessage.show('you are now logged in',{cssClass:'alert-success', timeout:5000});
        if(user.username == 'admin@my-media.tv')
        {
          this.router.navigate(['admin/accounts']);
        }else{
          this.router.navigate(['admin/rooms']);
        }

      //  location.reload();

      }else{
        //    this.flashMessage.show(data.msg,{cssClass:'alert-danger', timeout:5000});
        this.router.navigate(['login']);
        alert("Wrong Username or Password");
      }
    });
  }




}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts